import {Component, OnInit} from "@angular/core";
import {Convocation} from "../../shared/models/preregistration";
import {ConvocationService} from "../../shared/services/convocation/convocation.service";
import {debounceTime, take} from "rxjs/operators";
import {FormControl} from "@angular/forms";
import {environment} from "../../../environments/environment";
import {UserService} from "../../shared/services/user/user.service";
import {User} from "../../shared/models/user";

@Component({
    "selector": "app-convocation-list",
    "templateUrl": "./convocation-list.component.html",
    "styleUrls": ["./convocation-list.component.scss"]
})
export class ConvocationListComponent implements OnInit {

    convocations: Array<Convocation> = [];
    searchTermControl: FormControl;
    confirmationFilterControl: FormControl;
    user: User;
    loading: boolean;

    // Pagination related
    page: number;
    pageSize: number;
    itemsCount: number;

    // Counts by status (for filter pills)
    statusCounts: {total: number, confirmed: number, not_confirmed: number} = {
        total: 0,
        confirmed: 0,
        not_confirmed: 0
    };

    constructor (
        private convocationService: ConvocationService,
        private userService: UserService
    ) {
        this.loading = false;
        this.page = 1;
        this.pageSize = environment.pageSize;
        this.searchTermControl = new FormControl("");
        this.confirmationFilterControl = new FormControl("all");
    }

    ngOnInit () {
        // Subscribe to the change of value of the search field
        this.searchTermControl.valueChanges.pipe(debounceTime(1000)).
            subscribe(() => {
                this.page = 1; // Reset to page 1 on search
                this.fetchStatusCounts();
                this.fetchItemCount();
                this.fetchCurrentPage();
            });

        // Subscribe to confirmation filter changes
        this.confirmationFilterControl.valueChanges.subscribe(() => {
            this.page = 1; // Reset to page 1 on filter change
            this.fetchStatusCounts();
            this.fetchItemCount();
            this.fetchCurrentPage();
        });

        this.fetchStatusCounts();
        this.fetchItemCount();
        this.fetchCurrentPage();

        this.userService.getMe().pipe(take(1)).subscribe(
            (user: User) => {
                this.user = user;
            },
            (error) => {
                console.error("Erreur lors de la récupération de l'utilisateur:", error);
            }
        );
    }

    onPageChange (page: number) {
        this.page = page;
        this.fetchCurrentPage();
    }

    fetchItemCount () {
        const term = this.searchTermControl.value;
        const confirmationFilter = this.confirmationFilterControl.value;

        this.convocationService.count(term, confirmationFilter).pipe(take(1)).
            subscribe(
                (count: number) => {
                    this.itemsCount = count;
                },
                (error) => {
                    console.error("Erreur lors du comptage des convocations:", error);
                    this.itemsCount = 0;
                }
            );
    }

    fetchCurrentPage () {
        this.loading = true;

        const term = this.searchTermControl.value;
        const confirmationFilter = this.confirmationFilterControl.value;

        this.convocationService.list(this.page, term, confirmationFilter).pipe(take(1)).
            subscribe(
                (convocations: Array<Convocation>) => {
                    this.convocations = convocations;
                    this.loading = false;
                },
                (error) => {
                    console.error("Erreur lors de la récupération des convocations:", error);
                    this.convocations = [];
                    this.loading = false;
                }
            );
    }

    fetchStatusCounts () {
        const term = this.searchTermControl.value;

        this.convocationService.countByStatus(term).pipe(take(1)).
            subscribe(
                (counts) => {
                    this.statusCounts = counts;
                },
                (error) => {
                    console.error("Erreur lors du comptage par statut:", error);
                    this.statusCounts = {total: 0, confirmed: 0, not_confirmed: 0};
                }
            );
    }

    setConfirmationFilter (filter: string) {
        this.confirmationFilterControl.setValue(filter);
    }
}
